import { ApiErrorData, ApiResponse } from 'models/ApiResponse';
import { DiClient } from 'models/DiClient';

import { FunctionsHelper } from 'utils/FunctionsHelper';
import MainBackendAxios from 'utils/MainBackendAxios';

export const DiClientService = {
  getByCurrentCompany: async (): Promise<
    ApiResponse<DiClient[] | ApiErrorData>
  > => {
    try {
      const response = await MainBackendAxios.get(
        `/di/client/get-by-current-company`
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
};
